import { GridColDef } from "@mui/x-data-grid"
import { Warehouse } from "../../../../../interfaces/Stocks/Warehouses/warehouses"
import { useDates } from "../../../../../hooks/useDates";
import { useTranslation } from "react-i18next";

export const useColumnsWarehouses = () => {
  const { TimeConverter } = useDates();
  const [t] = useTranslation("global");

  const columnsWarehouses: GridColDef<Warehouse>[] = [
    { field: 'warehouse_code', headerName: t("warehouses.fields.warehouse_code"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'warehouse_description', headerName: t("warehouses.fields.warehouse_description"), headerClassName: 'header-grid-table', flex: 1 },
    { field: 'is_owned_by_the_company', headerName: t("warehouses.fields.is_owned_by_the_company"), headerClassName: 'header-grid-table', flex: 1, type: 'boolean' },
    {
      field: 'creation_date', headerName: t("generic.creation_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
    { field: 'last_update_user', headerName: t("generic.last_update_user"), headerClassName: 'header-grid-table', flex: 1 },
    {
      field: 'last_update_date', headerName: t("generic.last_update_date"), headerClassName: 'header-grid-table', type: "date", flex: 1,
      valueGetter(params) {
        return TimeConverter(params.value);
      },
    },
  ];

  return {
    columnsWarehouses,
  }
}
